export enum OverrideFormFieldEnum {
    DATE = 'date',
    TIME = 'time',
}

export interface OverrideFormInterface {
    [OverrideFormFieldEnum.DATE]: string;
    [OverrideFormFieldEnum.TIME]: string;
}
